import SubscriberModel from './subscriber.model'
import ProductModel from './product.model'
import BaseModel from './base.model';

export default class SimModel extends BaseModel {

  id = 0;
  products = [];
  deal = null;
  data = null;
  mins = null;
  sms = null;
  whatsApp = null;
  subscriber = null;
  iccid = "";
  connection_fee = 29;
  require_delivery = false;
  product_type = 'mobile';  
  user_form = "";
  
  constructor (data) {
    super();
    if (this.isEmpty(data)) return this;
    this.id = data.id;
    this.deal = data.deal ? new ProductModel(data.deal) : null;
    this.data = data.data ? new ProductModel(data.data) : null;
    this.mins = data.mins ? new ProductModel(data.mins) : null;
    this.sms = data.sms ? new ProductModel(data.sms) : null;
    this.whatsApp = data.whatsApp ? new ProductModel(data.whatsApp) : null;
    this.subscriber = new SubscriberModel(data.subscriber);
    this.iccid = data.iccid;
    this.connection_fee = this.updateConnectionFee(this.deal, data.connection_fee);
    this.require_delivery = this.updateRequireDelivery(this.deal, !(this.isEmpty(data.iccid) || data.iccid == ""));
    this.product_type = this.isEmpty(data.product_type) ? this.product_type : data.product_type;    
    this.updateSimProducts();
    this.user_form = data.user_form;
    console.log("NEW SIM", this);
  }

  updateSimProducts() {
    !this.isEmpty(this.deal) ? this.products.push(this.deal.id) : false;
    !this.isEmpty(this.data) ? this.products.push(this.data.id) : false;
    !this.isEmpty(this.mins) ? this.products.push(this.mins.id) : false;
    !this.isEmpty(this.sms) ? this.products.push(this.sms.id) : false;
    !this.isEmpty(this.whatsApp) ? this.products.push(this.whatsApp.id) : false;
  }

  updateRequireDelivery(deal, hasIccid) {        
    var meta = this.getMetaData(deal != null ? deal.display_details : null)    
    if(meta) {                  
      if(typeof(meta.require_delivery_fee) != "undefined"){
        console.log("DELIVERY", meta.require_connection_fee);
        return meta.require_delivery_fee;
      } 
    }
    return !hasIccid && (!this.isEmpty(deal) && deal.product_type != 'fixed-lte');
  }

  updateConnectionFee(deal, connection_fee) {    
    var meta = this.getMetaData(deal != null ? deal.display_details : null)    
    if(meta) {            
      if(typeof(meta.require_connection_fee) != "undefined"){
        console.log("CONNECTION FEE", meta.require_connection_fee ? connection_fee : 0);
        return meta.require_connection_fee ? connection_fee : 0;
      }
    }

    return this.isEmpty(deal) ? connection_fee : deal.product_type != 'fixed-lte' ? connection_fee : 0;
  }

  getMetaData(details) {
    var meta = details == null ? "" : details.meta_description;
    console.log("getMetaData", meta);
    if (meta == "") return false;
    return JSON.parse(meta);            
  }
}
